import { useState } from 'react';
import config from '../config/config';

export function useReportApi() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateReport = async (reportData) => {
    setLoading(true);
    setError(null);

    try {
      console.log('Sending report request:', reportData);
      
      const response = await fetch(`${config.API_URL}/report-writer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(reportData),
      });

      let data;
      const textResponse = await response.text();
      console.log('Raw response:', textResponse);

      try {
        if (!textResponse) {
          console.error('Empty response received');
          throw new Error('서버로부터 빈 응답이 반환되었습니다.');
        }
        data = JSON.parse(textResponse);
        console.log('Parsed response:', data);
      } catch (parseError) {
        console.error('Response parsing error:', {
          error: parseError,
          response: textResponse
        });
        throw new Error('서버 응답을 처리하는 중 오류가 발생했습니다.');
      }

      if (!response.ok) {
        throw new Error(data.error || '보고서 생성 중 오류가 발생했습니다.');
      }

      return data;
    } catch (error) {
      console.error('Report generation error:', {
        message: error.message,
        url: `${config.API_URL}/report-writer`,
        config: config
      });
      setError(error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    generateReport,
    loading,
    error,
  };
} 